import { Dispatch } from 'react';
import { post } from 'communication/httpClient';
import {
  LOAD_ITEM_GROUPS,
  ITEM_GROUPS_LOADED,
  RESET_ITEM_GROUPS,
  SYNC_FAILED,
} from './actionTypes';
import { IItemGroupsAction, IItemGroupsActions } from './types';

export const initialActionsState = {
  loadItemGroups: () => {},
  resetItemGroups: () => {},
};

export const getActions = (dispatch: Dispatch<IItemGroupsAction>): IItemGroupsActions => ({
  loadItemGroups: async () => {
    dispatch({
      type: LOAD_ITEM_GROUPS,
    });
    const { data, error } = await post('/api/item-groups', {});

    if (data) {
      dispatch({
        type: ITEM_GROUPS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetItemGroups: () =>
    dispatch({
      type: RESET_ITEM_GROUPS,
    }),
});
